import { useState, useEffect } from 'react'

const breakpointsDown = {
  sm: '(max-width: 639px)', // below sm
  md: '(max-width: 767px)', // below md
  lg: '(max-width: 1023px)', // below lg
  xl: '(max-width: 1279px)', // below xl
  '2xl': '(max-width: 1535px)', // below 2xl
}

const useMediaQuery = (query: string): boolean => {
  const [matches, setMatches] = useState(false)

  useEffect(() => {
    const media = window.matchMedia(query)
    if (media.matches !== matches) {
      setMatches(media.matches)
    }
    const listener = () => setMatches(media.matches)
    media.addEventListener('change', listener)
    return () => media.removeEventListener('change', listener)
  }, [matches, query])

  return matches
}

export const useMediaQuerySM = () => useMediaQuery(breakpointsDown.sm)
export const useMediaQueryMD = () => useMediaQuery(breakpointsDown.md)
export const useMediaQueryLG = () => useMediaQuery(breakpointsDown.lg)
export const useMediaQueryXL = () => useMediaQuery(breakpointsDown.xl)
export const useMediaQuery2XL = () => useMediaQuery(breakpointsDown['2xl'])

// Hook specifically for sidebar collapse at lg breakpoint (1023px)
export const useIsMobileLG = () => useMediaQuery(breakpointsDown.lg)

export default useMediaQuery
